import { Box, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const BookingNoteInput = (props) => {
    const { note, onChange, readonly } = props;
    const { t } = useTranslation();
    return (
        <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
            <Typography>{t("CreateBookingForm.bookingNote")}</Typography>
            <TextField
                value={note}
                onChange={(e) => onChange?.(e.target.value)}
                fullWidth
                rows={1}
                variant="outlined"
                disabled={readonly}
            />
        </Box>
    );
};
